import * as position from './position';
import * as resume from './resume';

const apis = {
  position,
  resume,
  oss: {
    loader: async ({ params }) => {
      const mapping = {
        candidate: '/candidate.html'
      };
      return new Promise(resolve => {
        setTimeout(() => {
          resolve((window.runtimePublicUrl || '') + mapping[params.id]);
        }, 1000);
      });
    }
  }
};

export default apis;
